const getBudgetId = budget => budget?.budget ?? budget?.id;

const matchesBudgetId = (budget, budgetId) => {
  const candidateBudgetId = getBudgetId(budget);

  if (
    candidateBudgetId === null ||
    candidateBudgetId === undefined ||
    budgetId === null ||
    budgetId === undefined
  ) {
    return false;
  }

  return candidateBudgetId.toString() === budgetId.toString();
};

export const buildOptimisticCreatedBudgetTabs = (tabs, budget) => {
  const budgetId = getBudgetId(budget);
  const currentTabs = Array.isArray(tabs) ? tabs : [];

  if (budgetId === null || budgetId === undefined) {
    return currentTabs;
  }

  const normalizedBudgetId = budgetId.toString();
  const existingTabs = currentTabs.filter(
    tab => getBudgetId(tab)?.toString() !== normalizedBudgetId
  );
  const optimisticTab = {
    ...budget,
    id: `pending-budget-tab-${budgetId}`,
    budget: budgetId,
    is_active: currentTabs.length === 0,
    is_optimistic: true,
  };

  return [optimisticTab, ...existingTabs];
};

export const buildOptimisticDeletedBudgetState = ({
  tabs,
  budgetId,
  selectedTab,
}) => {
  const currentTabs = Array.isArray(tabs) ? tabs : [];
  const deletedTabIndex = currentTabs.findIndex(tab =>
    matchesBudgetId(tab, budgetId)
  );

  if (deletedTabIndex < 0) {
    return {
      tabs: currentTabs,
      selectedTab,
    };
  }

  const remainingTabs = currentTabs.filter(
    tab => !matchesBudgetId(tab, budgetId)
  );
  const deletingSelectedTab = matchesBudgetId(selectedTab, budgetId);

  if (!deletingSelectedTab) {
    return {
      tabs: remainingTabs,
      selectedTab,
    };
  }

  const nextSelectedTab = remainingTabs[0];

  return {
    tabs: remainingTabs.map(tab => ({
      ...tab,
      is_active: matchesBudgetId(tab, getBudgetId(nextSelectedTab)),
    })),
    selectedTab: nextSelectedTab,
  };
};

export const isInitialBudgetWorkspaceLoading = ({
  budgetsStatus,
  tabsStatus,
  openTabsList,
}) => {
  const queryIsLoading =
    budgetsStatus === 'loading' || tabsStatus === 'loading';

  return queryIsLoading && !Array.isArray(openTabsList);
};

export const hasServerBackedCreatedBudgetTab = (tabs, budgetId) => {
  if (!Array.isArray(tabs) || budgetId === null || budgetId === undefined) {
    return false;
  }

  return tabs.some(
    tab =>
      getBudgetId(tab)?.toString() === budgetId.toString() &&
      !tab?.is_optimistic
  );
};

export const addBudgetToCachedList = (cachedResponse, budget) => {
  if (!cachedResponse || !Array.isArray(cachedResponse.data) || !budget?.id) {
    return cachedResponse;
  }

  return {
    ...cachedResponse,
    data: [
      budget,
      ...cachedResponse.data.filter(
        existingBudget =>
          existingBudget?.id?.toString() !== budget.id.toString()
      ),
    ],
  };
};

export const removeBudgetFromCachedList = (cachedResponse, budgetId) => {
  if (!cachedResponse || !Array.isArray(cachedResponse.data)) {
    return cachedResponse;
  }

  return {
    ...cachedResponse,
    data: cachedResponse.data.filter(
      budget => budget?.type === 'Folder' || !matchesBudgetId(budget, budgetId)
    ),
  };
};

export const removeBudgetFromCachedTabs = (
  cachedResponse,
  budgetId,
  selectedTab
) => {
  if (!cachedResponse || !Array.isArray(cachedResponse.data)) {
    return cachedResponse;
  }

  const nextState = buildOptimisticDeletedBudgetState({
    tabs: cachedResponse.data,
    budgetId,
    selectedTab,
  });

  return {
    ...cachedResponse,
    data: nextState.tabs,
  };
};
